/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShopView = {
    /**
     * Shop UUID
     */
    shopId: string;
    /**
     * Shop host URL
     */
    host: string;
    /**
     * Shop type
     */
    shopType: ShopView.shopType;
    /**
     * Shop settings as key-value pairs
     */
    settings?: Array<{
        key?: string;
        value?: string;
    }> | null;
    /**
     * Shop notifications
     */
    notifications?: Array<{
        notification_type?: 'new_order' | 'site_down' | 'site_up' | 'sync_interval' | 'report_daily' | 'report_weekly' | 'report_monthly' | 'report_daily_time' | 'report_weekly_time' | 'report_monthly_time';
        /**
         * Boolean for toggles, seconds for sync_interval, "HH:MM" for report times
         */
        value?: any;
    }> | null;
    /**
     * Is shop enabled
     */
    isEnabled: boolean;
    /**
     * Is shop online
     */
    isOnline: boolean;
};
export namespace ShopView {
    /**
     * Shop type
     */
    export enum shopType {
        JTL_SHOP_5 = 'jtl_shop_5',
        JTL_WAWI_1_5 = 'jtl_wawi_1_5',
        JTL_WAWI_1_6 = 'jtl_wawi_1_6',
        EBAY_SHOP = 'ebay_shop',
        AMAZON_SHOP = 'amazon_shop',
        SHOPIFY_SHOP = 'shopify_shop',
    }
}

